// extracted by mini-css-extract-plugin
export default {"triangleDown":"Pricing_triangleDown__6Dsfs","Header":"Pricing_Header__TsOie"};